import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatActivityList = createCustomElementWrapper('kat-activity-list', 'KatActivityList', {}, {
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});
